import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Car, Bike, Snowflake, Landmark, TreePine, Route, ArrowRight } from 'lucide-react';
import { tourCategories } from '../../data/mockData';

const iconMap = {
  Mountain: Mountain,
  Car: Car,
  Bike: Bike,
  Snowflake: Snowflake,
  Landmark: Landmark,
  TreePine: TreePine,
  Route: Route,
};

const bgColors = [
  'from-emerald-500 to-teal-600',
  'from-amber-500 to-orange-600',
  'from-sky-500 to-blue-600',
  'from-violet-500 to-purple-600',
  'from-rose-500 to-pink-600',
  'from-lime-500 to-green-600',
  'from-cyan-500 to-teal-600',
];

const Categories = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">What We Offer</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Choose Your Adventure
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From adrenaline-pumping treks to peaceful nature retreats, we have something for every adventurer.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {tourCategories.map((category, index) => {
            const Icon = iconMap[category.icon];
            return (
              <Link
                key={category.id}
                to={`/${category.id}`}
                className="group relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${bgColors[index % bgColors.length]} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                
                <div className="relative p-8">
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${bgColors[index % bgColors.length]} flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors`}>
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-white transition-colors mb-2">
                    {category.name}
                  </h3>
                  <p className="text-gray-600 group-hover:text-white/80 transition-colors mb-4">
                    {category.description}
                  </p>
                  
                  <div className="flex items-center text-emerald-600 group-hover:text-white font-semibold">
                    Explore
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-2 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
